import {
  ready,
  loader,
  redirect,
  messenger,
  isUserStuck,
  tryAgainMsg,
  createReporter,
  getSooperPanelProps,
  SooperBrowserStorage,
  createHiddenSubmitForm,
  anuraCallback,
} from './common';
import { wrap } from 'comlink';
import { isEmpty } from 'lodash';
import 'es6-promise/auto';
import Panel from './components/Panel';
import Profile from './components/Profile';
import Loader from './components/Loader';
import Controller from './components/Controller';
import Processor from './components/Processor';
import Creative from './components/Creative';
import Detour from './components/Detour';

const redirectTimeout = 12e3;

const init = async ({ profile, ...container }) => {
  const continueBtn = container.wrapper.querySelector('#continue'),
    browserStorage = new SooperBrowserStorage(),
    props = {
      profile,
      ...getSooperPanelProps(container.wrapper),
      browserStorage,
    },
    processor = new Processor({
      browserStorage,
      dispatcher: await messenger('/api/sooper/flow'),
      reporter: await createReporter(props.log_events),
    }),
    controller = new Controller({
      processor,
      continueBtn,
      creative: new Creative(),
      label: document.getElementById('labels'),
      // label: container.wrapper.querySelector('#labels'),
    });

  continueBtn.addEventListener('click', async (e) => {
    e.preventDefault(e);
    e.target.disabled = true;

    loader({
      continueBtn,
      status: 'hidden',
      panel: controller.active.elem,
    });

    // if (e.target.classList.contains('minSubBtn')) {
    //   ga('send', 'event', 'button', 'click', 'confirm before its too late');
    //   gtag('event', 'email_entered');
    //   // New Email Submit
    //   gtag('event', 'conversion', {
    //     send_to: 'AW-432472621/EBWVCKvH0usYEK2EnM4B',
    //     transaction_id: '',
    //   });
    // }

    if (e.target.classList.contains('submit')) {
      // stop trusted form recording
      if (typeof trustedFormStopRecording === 'function') {
        trustedFormStopRecording();
      }

      // gtag('event', 'offer_detail_seen');

      // // 	Email Submit
      // gtag('event', 'conversion', {
      //   send_to: 'AW-432472621/hcdJCOO6ivUBEK2EnM4B',
      // });

      // // EW Email Submit
      // gtag('event', 'conversion', {
      //   send_to: 'AW-432472621/LSc6CIfc0fgCEK2EnM4B',
      // });

      // // EW Email Submit (All Web Site Data)
      // ga('send', 'event', 'button', 'click', 'confirm entry');
    }

    await controller.submit(async ({ status_code, message, payload }) => {
      e.target.disabled = false;

      if (status_code === -1) {
        return tryAgainMsg(controller.active.field.parentNode);
      }

      if (status_code === -2) {
        return controller.previous();
      }

      await processor.response(controller.active.action, payload);

      const next = controller.next();

      if (next !== false) {
        return controller.toggle(controller.active, next);
      }

      await processor.report(controller.active);

      if (payload.hasOwnProperty('flow_driver') === false) {
        // return await redirect(
        //   `/offers.php${window.location.search}`,
        //   redirectTimeout,
        // );

        return createHiddenSubmitForm(
          {
            endpoint: 'offers.php',
            browser_id: props.browser_id,
          },
          () => {
            return setTimeout(
              async () => await isUserStuck(props.browser_id),
              redirectTimeout,
            );
          },
        );
      }

      switch (parseInt(payload.flow_driver)) {
        case 4:
        case 6:
          // return await redirect(
          //   `/offers.php${window.location.search}`,
          //   redirectTimeout,
          // );
          return createHiddenSubmitForm(
            {
              endpoint: 'offers.php',
              browser_id: props.browser_id,
            },
            () => {
              return setTimeout(
                async () => await isUserStuck(props.browser_id),
                redirectTimeout,
              );
            },
          );
        case 1:
        case 5:
        case 99:
          // return await redirect(
          //   `/full.php${window.location.search}`,
          //   redirectTimeout,
          // );
          return createHiddenSubmitForm(
            {
              endpoint: 'full.php',
              browser_id: props.browser_id,
            },
            () => {
              return setTimeout(
                async () => await isUserStuck(props.browser_id),
                redirectTimeout,
              );
            },
          );
        default:
          return createHiddenSubmitForm(
            {
              endpoint: 'full.php',
              browser_id: props.browser_id,
            },
            () => {
              return setTimeout(
                async () => await isUserStuck(props.browser_id),
                redirectTimeout,
              );
            },
          );
        //   return await redirect(
        //     `/full.php${window.location.search}`,
        //     redirectTimeout,
        //   );
      }
    });
  });

  container.panels.map((panel) => {
    panel.field.addEventListener('keypress', (e) => {
      if (e.key.toLowerCase() === 'enter') {
        e.preventDefault();
        continueBtn.click();
      }
    });
  });

  container.panels[0].toggle();

  return {
    props,
    ...container,
    controller,
  };
};

const setup = async () => {
  if (!document || !window.location) return;

  const profile = new Profile(),
    wrapper = document.getElementById('panel-wrapper'),
    panels = Array.from(wrapper.querySelectorAll('.panel')).reduce(
      (acc, elem) => {
        const field = elem.querySelector('input, select'),
          id = parseInt(elem.getAttribute('data-panel-key')) - 1;

        field.addEventListener(
          'blur',
          ({ target: { value } }) =>
            value.toString().length !== 0 &&
            field.classList.contains('error') &&
            field.classList.remove('error'),
          true,
        );

        // field.addEventListener(
        //   'focus',
        //   ({ target: { value } }) => {
        //     elem.querySelector('#res-msg')?.remove();
        //   },
        //   true,
        // );

        if (!isEmpty(field.value)) {
          profile[field.getAttribute('name')] = field.value;
        }

        acc[id] = new Panel({
          elem,
          field,
          name: field.name,
          action: elem.getAttribute('data-action') ?? false,
          id: parseInt(elem.getAttribute('data-panel-key')) - 1,
        });

        return acc;
      },
      [],
    );

  // add state, on state change and if logger is active, log data on state change.
  return await init({
    panels,
    wrapper,
    profile,
    query_params: Object.fromEntries(
      new URLSearchParams(window.location.search),
    ),
    anuraCallback: anuraCallback,
  });
};

ready(async () => {
  if (!window.sooper_panel) {
    window.sooper_panel = await setup();

    if (document.body.hasAttribute('is-detour')) {
      let controller = window.sooper_panel.controller,
        required = controller.processor.getRequiredProps(
          window.sooper_panel.panels[0],
        );

      const uri = '/api/sooper/flow',
        query = new URLSearchParams(window.location.search),
        detour = Detour.initialize(window.sooper_panel.props);

      window.sooper_panel.props.detourSphere = detour.sphere;

      if (window.sooper_panel.query_params?.no_redirect) {
        console.log('starting speedtest');
        // let speed = new SpeedTest();
      }

      // setTimeout(async () => {
      await detour.process([
        {
          name: 'lp_submit',
          endpoint: `${uri}/email?${query}`,
          payload: required,
          callback: async (response) => {
            await controller.processor.response('email', response);
            controller.creative.email_address.afterSubmit(
              controller.active,
              controller.next(),
            );
            return detour.sphere.animate(1.0);
          },
        },
        // {
        //   endpoint: `${uri}/direct_fpa?${query}`,
        // },
        {
          name: 'mp_submit',
          endpoint: `${uri}/submit?${query}`,
        },
        {
          name: 'of_submit',
          endpoint: `${uri}/sim/of1?${query}`,
          // callback: async () => {
          //   if (!window.sooper_panel.query_params?.no_redirect) {
          //     setTimeout(
          //       () =>
          //         (window.location = `/full.php?${new URLSearchParams(
          //           window.location.search,
          //         )}`),
          //       1000,
          //     );
          //   }
          // },
        },
      ]);
      // }, 100);
      // const required = processor.getRequiredProps(container.panels[0]);
      // console.log(required);
    }
  }
});
